/*
    Created by Phat Hoang Pham
    phat@launchdeck.org
*/

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { isCateringFilled, isHired, isNotHired } from '../utils/util_catering';
import { SceneCateringTagItem } from './component_catering_tag';

import GLOBAL from '../configs/config_global';
import { getGlobalState, STATE_KEYS } from '../configs/config_state';

export class SceneCateringClaimStatusTag extends PureComponent {
    // region Props
    static propTypes = {
        cateringData: PropTypes.object
    };

    static defaultProps = {
        cateringData: {}
    };
    // endregion

    // region Render Filled Tag
    renderFilledTag() {
        return(
            <SceneCateringTagItem
                text={'FILLED'}
                backgroundColor={GLOBAL.COLOR.TEXT_LIGHT_GRAY}
                textColor={GLOBAL.COLOR.TEXT_GRAY}
                style={{ marginBottom: 16 }}
            />
        );
    }
    // endregion

    // region MAIN RENDER FUNCTION
    render() {
        const {
            cateringData
        } = this.props;

        return(
            (isHired(cateringData, getGlobalState(STATE_KEYS.TRUCK_DATA).id) || isNotHired(cateringData, GLOBAL.MAIN?.state.truckData.id)) ?
                null
                :
                (
                    isCateringFilled(cateringData) ?
                        this.renderFilledTag()
                        :
                        (
                            cateringData['parent_status'] !== 1 ? // Can be 0 or 2
                                null // Either in the past or "Open" (no need to show because we already have the Pending tag)
                                :
                                (
                                    cateringData['child_status'] === 0 ?
                                        (
                                            cateringData['food_truck_id'] === 0 || (cateringData['food_truck_id'] !== 0 && (cateringData['extent_number'] > 1)) ? /* This lead was sent to multiple trucks */
                                                (
                                                    cateringData['total_accepted_truck'] >= GLOBAL.SETTINGS.MAX_CATERING_TRUCKS ?
                                                        (
                                                            cateringData['type'] === 1 ?
                                                                this.renderFilledTag()
                                                                :
                                                                null
                                                        )
                                                        :
                                                        <SceneCateringTagItem
                                                            text={'SLOTS LEFT: ' + (GLOBAL.SETTINGS.MAX_CATERING_TRUCKS - cateringData['total_accepted_truck'])}
                                                            backgroundColor={'rgba(250, 57, 61, 0.2)'}
                                                            textColor={GLOBAL.COLOR.MAIN}
                                                            style={{ marginBottom: 16 }}
                                                        />
                                                )
                                                :
                                                this.renderFilledTag()
                                        )
                                        :
                                        null
                                )
                        )
                )
        );
    }
    // endregion
}
